<template>
  <div v-if="description" class="detail-container">
    <div class="text detail">
      <span v-if="position && position.length > 0">{{ position }}. {{ name }}</span>
      <span v-else>{{ name }}</span>
    </div>
    <div :class="descriptionClasses">
      {{ description }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Detail",
  props: {
    position: {
      type: String,
    },
    name: {
      type: String,
    },
    description: {
      type: String,
    },
    capitalize: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    descriptionClasses() {
      const classes = ["text"];

      if (this.capitalize === true) {
        classes.push("description");
      }

      return classes;
    },
  },
};
</script>

<style scoped>
.detail-container {
  padding: 20px 0px;
}

.detail {
  font-weight: bold;
}

.description::first-letter {
  text-transform: uppercase;
}

.text {
  max-width: 90%;
}
</style>
